/**
 * Clear the tab session ID (e.g. on logout). Next `getSessionId()` creates a new one.
 * Intentionally isolated from `sessionGet.ts` so bundlers cannot place it in the same
 * chunk as unrelated UI that minifies to clashing top-level names (staging: TDZ on `C`).
 */
const SESSION_ID_KEY = "app_session_id";

export function clearSessionId(): void {
  try {
    if (typeof window !== "undefined" && window.sessionStorage) {
      window.sessionStorage.removeItem(SESSION_ID_KEY);
    }
  } catch {
    // ignore
  }
}
